<template>

 <v-app-bar
      light
      style="z-index:100"
    >
      <v-app-bar-nav-icon @click.stop="drawer = !drawer; openDrawer()"></v-app-bar-nav-icon>
      <v-toolbar-title><img src="/img/logo.svg" height="48px" @click="goHome()"/></v-toolbar-title>
      <div class="flex-grow-1"></div>

       <v-navigation-drawer app absolute temporary v-model="drawer">
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="title">
            <v-img src="/img/logo.svg" width="48px"></v-img>
          </v-list-item-title>
         
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>

      <v-list
        dense
        nav
      >
        <v-list-item
          v-for="item in items"
          :key="item.title"
          link
          :href="item.path"
        >
          <v-list-item-icon>
            <v-icon>{{ item.action }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
</v-app-bar>

        
</template>

<script> 
    import router from "@/plugins/router";

    export default {
        name: "toolbar",
        data: () => ({
            drawer: false,
            clipped: false,
            items: [{
                    action: 'mdi-plus',
                    title: 'DPD/DHL Upload',
                    path: '/carrierInvoices',
                    items: [],
                },
                {
                    action: 'mdi-box',
                    title: 'Kartonverwaltung',
                    path: '/cartons',
                    items: [],
                },
                {
                    action: 'mdi-box',
                    title: 'ACD Rechnungen',
                    path: '/acdInvoice',
                    items: [],
                }
            ]
        }),
        methods: {
            openDrawer() {
            },
            goHome() {
                router.push({name: "Apps" })
            }
        }
    }

</script>